import FetchData from './FetchData';

class Hotel{
    // constructor(id,identifier,hotelName,locationName,averageRating,votes,hotelUrl){
    //     this.id=id;
    //     this.identifier=identifier;
    //     this.hotelName=hotelName;
    //     this.locationName=locationName;
    //     this.averageRating=averageRating;
    //     this.votes=votes;
    //     this.hotelUrl=hotelUrl;
    // }

    constructor(id,identifier,hotelName,locationName,averageRating,votes,hotelUrl, 
            photoLink, description, price){
        this.id=id;
        this.identifier=identifier;
        this.hotelName=hotelName;
        this.locationName=locationName;
        this.averageRating=averageRating;
        this.votes=votes;
        this.hotelUrl=hotelUrl;

        this.photoLink = photoLink;
        this.description = description;
        this.price = price;
    }

    updateHotel(hotel,auth) {
        var data = {
            id : hotel.id,
            identifier : hotel.identifier,
            hotelName : hotel.hotelName,
            locationName : hotel.locationName,
            averageRating : hotel.averageRating,
            votes : hotel.votes,
            hotelUrl : hotel.hotelUrl,
            photoLink : hotel.photoLink,
            description : hotel.description,
            price : hotel.price
        };

        var response = FetchData.makeAuthRequest("https://euopendata.herokuapp.com/hotel/update_hotel", "POST", data, auth);
        return response; // return response.message;    
    }

    
}

export default Hotel; 